import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import IconButton from 'apollo-react/components/IconButton';
import ArrowDown from 'apollo-react-icons/ArrowDown';
import Menu from 'apollo-react-icons/Menu';
import React, { useState } from 'react';

import ActionsButtonMenuPopover from './ActionsButtonMenuPopover';
import { useTranslation } from '../../../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  marginRight: {
    marginRight: 15,
    '@media (max-width: 1200px)': {
      display: 'none',
    },
  },
  resetOverflow: {
    overflow: 'visible!important',
    minWidth: 'initial!important',
  },
  hiddenMenuButton: {
    display: 'none',
    '@media (max-width: 1200px)': {
      display: 'block',
    },
  },
});

export const ActionsButton = ({ actionItems, compactModeActionItems }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElCompactMode, setAnchorElCompactMode] = useState(null);

  const handleClick = ({ currentTarget }) => {
    setAnchorEl((prev) => (!prev ? currentTarget : null));
  };

  const handleClickCompactMode = ({ currentTarget }) => {
    setAnchorElCompactMode((prev) => (!prev ? currentTarget : null));
  };

  return (
    <>
      <div className={classes.hiddenMenuButton}>
        <IconButton onClick={handleClickCompactMode}>
          <Menu />
        </IconButton>

        <ActionsButtonMenuPopover
          items={compactModeActionItems}
          anchorEl={anchorElCompactMode}
          setAnchorEl={setAnchorElCompactMode}
        />
      </div>

      <div className={`${classes.marginRight} ${classes.resetOverflow}`}>
        <Button variant="secondary" onClick={handleClick}>
          {translateString('Actions')}
          <ArrowDown fontSize="extraSmall" style={{ marginLeft: 5 }} />
        </Button>

        <ActionsButtonMenuPopover
          items={actionItems}
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
        />
      </div>
    </>
  );
};

export default ActionsButton;
